import { defineMessages } from 'react-intl-next';

export const messages = defineMessages({
	recommended: {
		id: 'recommend-standard-over-premium.floating-recommendation.recommended',
		defaultMessage: 'Recommended',
		description: "One word to tell the user that the Standard edition is 'recommended' for them.",
	},
	basedOnYourUsage: {
		id: 'recommend-standard-over-premium.floating-recommendation.based-on-your-usage',
		defaultMessage: 'based on your usage',
		description: "This is the reason we're recommending the Standard edition to the user.",
	},
	gesturalLineAltText: {
		id: 'recommend-standard-over-premium.floating-recommendation.gestural-line-alt-text',
		defaultMessage: 'A gesture pointing towards the Standard edition',
		description:
			'An image of a line that gestures towards the Standard edition showing that Standard is being recommended.',
	},
});
